module.exports = __webpack_public_path__ + "0c123da905d9b8ef23398ef058a9a906.png";